<template>
    <div class="maincontainer" v-observe-visibility="visibilityChange">
        <template v-if="loaded && visible">
            {{$t('inspections.last')}}: {{lastInspection | formatDate}}
            <div>
                <line-chart :inspections="inspections" :devcats="devcats"></line-chart>
            </div>
            <div class="row" style="padding-top: 25px;" v-if="role != 'ddd_customer'">
                <div class="col offset-s9 s3">
                    <a :href='"#/customers/"+customer_id+"/places/"+place_id+"/inspections/new/edit"' class="waves-effect waves-light btn-small green">{{$t('menu.buttons.add_inspection')}}</a>
                </div>
            </div>
        </template>
        <table style="margin-top: 1em;">
            <thead>
                <tr>
                    <th v-on:click="set_order('date')">
                        <span>{{$t('inspections.last')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'date' && order == 'desc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'date' && order == 'asc'">arrow_drop_up</i>
                    </th>
                    <th v-on:click="set_order('notices')">
                        <span>{{$t('inspections.notices')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'notices' && order == 'desc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'notices' && order == 'asc'">arrow_drop_up</i>
                    </th>
                    <th v-on:click="set_order('total')" style="text-align: center;">
                        <span>{{$t('inspections.result')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'total' && order == 'desc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'total' && order == 'asc'">arrow_drop_up</i>
                    </th>
                    <th style="text-align: center;">
                        <span>{{$t('inspections.report')}}</span>
                    </th>
                    <th style="text-align: center;">
                        <span>{{$t('inspections.protocol')}}</span>
                    </th>
                    <th style="text-align: center;">
                        <span>{{$t('inspections.recommendations')}}</span>
                    </th>
                </tr>
            </thead>
            <tbody v-if="loaded">
                <template v-for="(inspection, index) in listItems">
                    <tr>
                        <td>{{inspection.date | formatDate}}</td>
                        <td style="width: 50vw; font-size: 12px;">
                            <template v-for="notice, i in inspection.notices">
                                {{notice}}<br v-if="i < (inspection.notices.length - 1)" />
                            </template>
                            <template v-if="editable && inspection.devchanges_applied == false">
                                <template v-if="inspection.temporary_inactivate.length > 0">
                                    <br/>{{$t('inspections.deactivate')}}: <template v-for="(change_suggestion, index) in inspection.temporary_inactivate"><template v-if="index > 0">, </template>{{change_suggestion}}</template>
                                </template>
                                 <template v-if="inspection.need_remove.length > 0">
                                    <br/>{{$t('inspections.need_remove')}}: <template v-for="(need_remove, index) in inspection.need_remove"><template v-if="index > 0">, </template>{{need_remove}}</template>
                                </template>
                                <template v-if="inspection.change_suggestions.length > 0">
                                    <br/>{{$t('inspections.need_change')}}: <template v-for="(change_suggestion, index) in inspection.change_suggestions"><template v-if="index > 0">, </template>{{change_suggestion.number}}</template>
                                </template>
                            </template>
                        </td>
                        <td style="text-align: center;white-space: nowrap;">{{inspection.total ? inspection.total : 0}} / {{inspection.out_of ? inspection.out_of : 0}}</td>
                        <td style="text-align: center;"><a :href='"#/customers/"+customer_id+"/places/"+place_id+"/inspections/"+inspection.id'><span class="material-icons dp6">equalizer</span></a></td>
                        <td style="text-align: center;"><a :href='"#/customers/"+customer_id+"/places/"+place_id+"/inspections/"+inspection.id+"/summary"'><span class="material-icons dp6">featured_play_list</span></a></td>
                        <td style="text-align: center;"><a :href='"#/customers/"+customer_id+"/places/"+place_id+"/inspections/"+inspection.id+"/recommendations"'><span class="material-icons dp6">check_box</span></a></td>
                    </tr>
                </template>
            </tbody>
            <preloader v-if="loaded == false" n="7" />
        </table>
        <div class="row" style="padding-top: 25px;">
            <div class="col offset-s9 s3">
                <a v-on:click="loadMore()" class="waves-effect waves-light btn-small green">{{$t('menu.buttons.show_more')}}</a>
            </div>
        </div>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters';
import LineChart from './linechart.vue';
import axios from 'axios';
import Moment from 'moment';
import 'moment/locale/pl'
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);
export default {
    data: function() {
        return {
            order: 'desc',
            orderby: 'date',
            places: [],
            loaded: false,
            datacollection: [],
            from: moment().startOf('year').format(),
            to: moment().endOf('year').format(),
            inspections: [],
            devcats: {},
            visible: false
        }
    },
    props: { customer_id: [String, Number], place_id: [String, Number], last_date: [String], editable: Boolean, role: String },
    async created() {
        if (this.last_date != null) {
            this.from = moment(this.last_date, 'YYYY-MM-DD').startOf('year').format(),
                this.to = moment(this.last_date, 'YYYY-MM-DD').endOf('year').format()
        }
        await this.fetch_places();
    },
    methods: {
        fetch_places: async function() {
            if (this.place_id != 0) {
                var response = await axios.get('/customers/' + this.customer_id + '/places/' + this.place_id + '/inspections/' + moment(this.from).unix() + '/' + moment(this.to).unix() + '.json')
                this.inspections = response.data;
                var response = await axios.get('/device_categories.json')
                this.devcats = _.keyBy(response.data, 'id');
            }
            this.loaded = true

        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        loadMore: async function() {
            this.loaded = false;
            this.inspections = [];
            this.from = moment(this.from).subtract(1, 'year').format();
            await this.fetch_places();
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }

            } else {
                this.orderby = order;
            }
        },
        visibilityChange(evt, hidden) {
            this.visible = evt;
        },
        zones_groupped(inspection, kind) {
            var reachedout = [];
            var reacheds = inspection.exceeded_individual_zones;
            for (var i = reacheds.length - 1; i >= 0; i--) {
                var reached = reacheds[i];
                for (var j = reached.pests_quantities.length - 1; j >= 0; j--) {
                    var pt = reached.pests_quantities[j];
                    if (pt.crit_calculation_method == kind) {
                        reachedout.push([reached.zone_name, reached.device_category_name, pt.pest_name, reached.device_number, pt])
                    }
                }

            }
            return _.groupBy(reachedout, function(arr) { return [arr[0], arr[1], arr[2]] });
        },
        zones_pest_anyofs_critical(inspection) {
                var reaches = [];
                var reachedout = [];
                if (inspection.exceeded_individual_zones != undefined) {
                    var groups = this.zones_groupped(inspection, "anyof")
                    var kis = _.keys(groups)
                    for (var i = kis.length - 1; i >= 0; i--) {
                        var kij = kis[i];
                        var sumCond = 0;
                        var pg = _.map(groups[kij], _.last);
                        for (var j = pg.length - 1; j >= 0; j--) {
                            sumCond += pg[j].quantity
                        }
                        var pestid = pg[0].pest_id;
                        var pt = _.find(pg[0].thresolds, { pest_id: pestid })
                        if (sumCond < pt.medium_activity_thresold) {
                            sumCond = 1
                        } else if (sumCond < pt.high_activity_thresold) {
                            sumCond = 2
                        } else if (sumCond < pt.very_activity_thresold) {
                            sumCond = 3
                        } else if (sumCond >= pt.medium_activity_thresold) {
                            sumCond = 4
                        }

                        var crit = _.first(pg).critical_point;
                        if (sumCond > crit) {
                            reaches.push(groups[kij]);
                        }
                    }
                }
                return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
            },
            zones_pest_anyofs_disaster(inspection) {
                var reaches = [];
                var reachedout = [];
                if (inspection.exceeded_individual_zones != undefined) {
                    var groups = this.zones_groupped(inspection, "anyof")
                    var kis = _.keys(groups)
                    for (var i = kis.length - 1; i >= 0; i--) {
                        var kij = kis[i];
                        var pg = _.map(groups[kij], _.last);
                        var conds = _.map(pg, 'conditions')
                        var suma = _.sum(conds);
                        var sumCond = 0;
                        if (sumCond < pg[0].thresolds.medium_activity_thresold) {
                            sumCond = 1
                        } else if (sumCond < pg[0].thresolds.high_activity_thresold) {
                            sumCond = 2
                        } else if (sumCond < pg[0].thresolds.very_activity_thresold) {
                            sumCond = 3
                        } else if (sumCond >= pg[0].thresolds.medium_activity_thresold) {
                            sumCond = 4
                        }
                        var disaster = _.first(pg).disaster_point;
                        if (sumCond > disaster) {
                            reaches.push(groups[kij]);
                        }
                    }
                }

                return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
            },
            zones_pest_avgs_critical(inspection) {
                var reaches = [];
                var reachedout = [];
                if (inspection.exceeded_individual_zones != undefined) {
                    var groups = this.zones_groupped(inspection, "avg");
                    var kis = _.keys(groups)
                    for (var i = kis.length - 1; i >= 0; i--) {
                        var kij = kis[i];
                        var pg = _.map(groups[kij], _.last);
                        var conds = _.map(pg, 'conditions')
                        var crit = _.first(pg).critical_point;
                        if (_.mean(conds) > crit) {
                            reaches.push(groups[kij]);
                        }
                    }
                }
                return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
            },
            zones_pest_avgs_disaster(inspection) {
                var reaches = [];
                var reachedout = [];
                if (inspection.exceeded_individual_zones != undefined) {
                    var groups = this.zones_groupped(inspection, "avg");
                    var kis = _.keys(groups)
                    for (var i = kis.length - 1; i >= 0; i--) {
                        var kij = kis[i];
                        var pg = _.map(groups[kij], _.last);
                        var conds = _.map(pg, 'conditions')
                        var disaster = _.first(pg).disaster_point;
                        if (_.mean(conds) > disaster) {
                            reaches.push(groups[kij]);
                        }
                    }
                }
                return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
            },
            zones_pest_meds_critical(inspection) {
                var reaches = [];
                var reachedout = [];
                if (inspection.exceeded_individual_zones != undefined) {
                    var groups = this.zones_groupped(inspection, "median");
                    var kis = _.keys(groups)
                    for (var i = kis.length - 1; i >= 0; i--) {
                        var kij = kis[i];
                        var pg = _.map(groups[kij], _.last);
                        var conds = _.map(pg, 'conditions')
                        var crit = _.first(pg).critical_point;
                        if (median(conds) > crit) {
                            reaches.push(groups[kij]);
                        }
                    }
                }
                return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
            },
            zones_pest_meds_disaster(inspection) {
                var reaches = [];
                var reachedout = [];
                if (inspection.exceeded_individual_zones != undefined) {
                    var groups = this.zones_groupped(inspection, "median");
                    var kis = _.keys(groups)
                    for (var i = kis.length - 1; i >= 0; i--) {
                        var kij = kis[i];
                        var pg = _.map(groups[kij], _.last);
                        var conds = _.map(pg, 'conditions')
                        var disaster = _.first(pg).disaster_point;
                        if (median(conds) > disaster) {
                            reaches.push(groups[kij]);
                        }
                    }
                }
                return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
            },
            zones_pest_maxes_critical(inspection) {
                var reaches = [];
                var reachedout = [];
                if (inspection.exceeded_individual_zones != undefined) {
                    var groups = this.zones_groupped(inspection, "max");
                    var kis = _.keys(groups)
                    for (var i = kis.length - 1; i >= 0; i--) {
                        var kij = kis[i];
                        var pg = _.map(groups[kij], _.last);
                        var conds = _.map(pg, 'conditions')
                        var crit = _.first(pg).critical_point;
                        for (var j = groups[kij].length - 1; j >= 0; j--) {
                            var grup = groups[kij][j]
                            if (grup[4].conditions > crit) {
                                reaches.push(grup);
                            }
                        }

                    }
                }
                return Object.entries(_.groupBy(reaches, function(list) { return [list[0], list[1], list[2]].join(" / "); }));
            },
            zones_pest_maxes_disaster(inspection) {
                var reaches = [];
                var reachedout = [];
                if (inspection.exceeded_individual_zones != undefined) {
                    var groups = this.zones_groupped(inspection, "max");
                    var kis = _.keys(groups)
                    for (var i = kis.length - 1; i >= 0; i--) {
                        var kij = kis[i];
                        var pg = _.map(groups[kij], _.last);
                        var conds = _.map(pg, 'conditions')
                        var disaster = _.first(pg).disaster_point;
                        if (_.max(conds) > disaster) {
                            reaches.push(groups[kij]);
                        }
                    }
                }
                return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
            },
            zones_pests_critical(inspection){
                var out = []
                if(this.zones_pest_anyofs_critical(inspection).length > 0){
                    out.push({kind: 'anyof', items: this.zones_pest_anyofs_critical(inspection)})
                }
                if(this.zones_pest_avgs_critical(inspection).length > 0){
                    out.push({kind: 'avg', items: this.zones_pest_avgs_critical(inspection)})
                }
                if(this.zones_pest_maxes_critical(inspection).length > 0){
                    out.push({kind: 'max', items: this.zones_pest_maxes_critical(inspection)})
                }
                if(this.zones_pest_meds_critical(inspection).length > 0){
                    out.push({kind: 'med', items: this.zones_pest_meds_critical(inspection)})
                }
                return out;
            },
    },
    computed: {
        listItems() {
            return _.orderBy(this.inspections, this.orderby, this.order);
        },
        lastInspection: function() {
            var inps = _.last(_.orderBy(this.inspections, 'date'));
            if (_.isUndefined(inps) == false)
                return inps.date;
            return "-"
        },
    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.maincontainer {
    text-align: left;
}

p {
    font-size: 2em;
    text-align: center;
}

thead th {
    font-weight: 300;
}

thead .input-field {
    margin-top: unset;
    margin-bottom: unset;
}
</style>
